if ("NodeList" in window && !NodeList.prototype.forEach) {
	console.info("polyfill for IE11");
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

Date.prototype.addHours = function (h) {
	this.setHours(this.getHours() + h);
	return this;
};

Date.prototype.addMinutes = function (m) {
	this.setMinutes(this.getMinutes() + m);
	return this;
};

(function () {
	$(".header__burger-lines").click(function (event) {
		$(".header").toggleClass("open-menu");
		$(".burger").slideToggle();
	});

	$(".primary-nav-2").prepend(
		`<div class="description">${translations.primary_nav_descriptions.default.nav2}</div>`
	);
	if($('body').hasClass('se-asian')) {
		$(".primary-nav-3").prepend(
			`<div class="description">${translations.primary_nav_descriptions.se_asian.nav3}</div>`
		);
		$(".primary-nav-4").prepend(
			`<div class="description">${translations.primary_nav_descriptions.se_asian.nav4}</div>`
		);
		$(".primary-nav-5").prepend(
			`<div class="description">${translations.primary_nav_descriptions.se_asian.nav5}</div>`
		);
		$(".primary-nav-8").prepend(
			`<div class="description">${translations.primary_nav_descriptions.se_asian.nav8}</div>`
		);
		$(".primary-nav-9").prepend(
			`<div class="description">${translations.primary_nav_descriptions.se_asian.nav9}</div>`
		);
	} else if($('body').hasClass('inclusive')) {
		$(".primary-nav-3").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav3}</div>`
		);
		$(".primary-nav-4").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav4}</div>`
		);
		$(".primary-nav-5").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav5}</div>`
		);
		$(".primary-nav-6").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav6}</div>`
		);
		$(".primary-nav-9").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav9}</div>`
		);
		$(".primary-nav-10").prepend(
			`<div class="description">${translations.primary_nav_descriptions.inclusive.nav10}</div>`
		);
	} else {
		$(".primary-nav-3").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav3}</div>`
		);
		$(".primary-nav-4").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav4}</div>`
		);
		$(".primary-nav-5").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav5}</div>`
		);
		$(".primary-nav-6").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav6}</div>`
		);
		$(".primary-nav-9").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav9}</div>`
		);
		$(".primary-nav-10").prepend(
			`<div class="description">${translations.primary_nav_descriptions.default.nav10}</div>`
		);
	}
 
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll("p") || [];
	paragraph.forEach(
		(e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
	);

	$(".sym-slides").slick({
		accessibility: true
	});

	$(".wellbeing-videos__previews").slick({
		accessibility: true,
		autoplaySpeed: 8000,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		rtl: langSelected == "ar" ? true : false,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	//data-slick='{"arrows": true, "asNavFor": ".gallery-slide", "speed": 500, "slidesToShow":4 , "slidesToScroll": 1 , "variableWidth":true}'

	$(".gallery-block__firstrow").slick({
		accessibility: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		rtl: langSelected == "ar" ? true : false,
		arrows: false,
		centerMode: true,
		variableWidth: true,
		asNavFor: ".gallery-slide",
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					variableWidth: false,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
				},
			},
		]
	}); 

	$(".gallery-block__secondrow").slick({
		accessibility: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		rtl: langSelected == "ar" ? true : false,
		arrows: true,
		variableWidth: true,
		centerMode: true,
		asNavFor: ".gallery-slide",
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					variableWidth: false,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
				},
			},
		]
	});

	// $('.gallery-block__secondrow').slick({
	//     accessibility: true,
	// 	infinite: true,
	// 	speed: 300,
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	dots: false
	// });

	$(".scroll-down").click(function () {
		$("html, body").animate(
			{
				scrollTop: $(".intro").offset().top,
			},
			1000
		);
	});

	$(".ftscs-slider-config").slick({
		accessibility: true,
		infinite: true,
		fade: true,
		speed: 400,
		// slidesToShow: 1,
		// slidesToScroll: 1,
		arrows: true,
		rtl: langSelected == "ar" ? true : false,
		pauseOnHover: false,
		autoplaySpeed: 8000,
		autoplay: true,
		dots: false,
		responsive: [
			{
				breakpoint: 700,
				settings: {
					adaptiveHeight: true,
				},
			},
		]
	});

	//Dropdown language

	const selected = document.querySelector(".drop-down .selected a");

	if (selected) {
		const ulDropwdown = document.querySelector(".drop-down .options ul");

		selected.addEventListener("click", (e) => {
			e.preventDefault();
			ulDropwdown.classList.toggle("open");
		});

		document
			.querySelectorAll(".drop-down .options ul li a")
			.forEach((elm) => {
				elm.addEventListener("click", function (e) {
					e.preventDefault();
					// let text = this.textContent
					// selected.innerHTML = text
					ulDropwdown.classList.remove("open");
				});
			});
	}

	let navbar = document.getElementById("stickyHeaderMenus");
	let sticky = null;
	if (navbar) {
		// sticky = navbar.offsetTop;
		sticky = window.pageYOffset + navbar.getBoundingClientRect().top + 260;
		console.log("sh sticky", sticky);
	}

	window.addEventListener("scroll", function () {
		scrollW();
	});

	window.onscroll = function () {
		stickyMenu();
	};

	function stickyMenu() {
		if (navbar) {
			if (window.pageYOffset >= sticky) {
				navbar.classList.add("sticky");
			} else {
				navbar.classList.remove("sticky");
			}
		}
	}

	subNavigationFunctionality();
	// middlewareReferall();
	listenChangeLanguage();

	loadYourStoryData();
})(); 

var lastScrollTop = 0;

function scrollW() {
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName("animate");
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if (topPos <= window_height * 1) {
			animatedEl[i].classList.add("fade-in");
			animatedEl[i].classList.remove("fade-out");
		} else {
			animatedEl[i].classList.remove("fade-in");
			animatedEl[i].classList.add("fade-out");
		}
	}
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function subNavigationFunctionality() {
	const navItems = document.querySelectorAll("#privary-navigation > li > a");

	navItems.forEach((item) => {
		item.addEventListener("click", function (e) {
			console.log("item...", item);
			if (this.nextElementSibling && this.previousElementSibling) {
				e.preventDefault();
				this.nextElementSibling.classList.toggle("open-submenu");
				this.parentElement.classList.toggle("open-submenu");
			}
		});
	});
}

// Check if a client has the param &referral=menus in the URL
// or If the data exists in the local storage and is not expired
function checkIfExistReferral() {
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);
	const queryParam = params.get("referral");
	if (queryParam === "none") {
		localStorage.removeItem("menus");
		localStorage.removeItem("share");
		return false;
	}

	if (localStorage.getItem("menus")) {
		const { expired } = JSON.parse(localStorage.getItem("menus"));
		console.log("@+", new Date(expired), new Date());
		if (new Date() > new Date(expired)) {
			localStorage.removeItem("menus");
		} else {
			return true;
		}
	}

	if (queryParam === "menus") {
		const date = is_live == "1" ? new Date().addHours(1) : new Date().addMinutes(5);
		localStorage.setItem("menus", JSON.stringify({ expired: date }));
		return true;
	}

	return false;
}

function listenChangeLanguage() {
	$(".drop-down .options a").click(function (e) {
		e.preventDefault();
		let langSel = this.dataset.value;
		let pathname = document.location.pathname;
		let origin = document.location.origin;
		let langs = [
			"es",
			"fr",
			"de",
			"pt",
			"it",
			"ko",
			"ja",
			"ru",
			"nl",
			"zh-CN",
		];
		for (const key in langs) {
			if (pathname.indexOf(`/${langs[key]}/`) > -1)
				pathname = pathname.replace(`/${langs[key]}/`, "");
		}

		if (langSel != "en") {
			if ($("body").attr("id") === "home")
				document.location = origin + "/" + langSel;
			else {
				let newUrl = langSel + "/" + pathname;
				newUrl = newUrl.replace("//", "/");
				document.location = origin + "/" + newUrl;
			}
		} else {
			if ($("body").attr("id") === "home")
				document.location = origin + "/";
			else document.location = origin + "/" + pathname;
		}
	});
}

/**
 * Checks the share local store and performs actions based on the query parameter.
 *
 * @param {boolean} [removeBurgerLines=false] - Flag indicating whether to remove burger lines.
 * @return {Promise<string>} A promise that resolves to a JSON string containing the share value and expiration date.
 */
function checkShareLocalStore(removeBurgerLines = false) {
	if (removeBurgerLines) {
		document.querySelector(".header__burger-lines").classList.remove("hidden");
	}
	const params = new URLSearchParams(window.location.search);
	const queryParam = params.get("share");
	const date = is_live == "1" ? new Date().addHours(1) : new Date().addMinutes(5);
	if (queryParam) {
		if (localStorage.getItem("share") !== null) {
			console.log("Call-Local");
			const { value, expired } = JSON.parse(
				localStorage.getItem("share")
			);
			if (new Date() > new Date(expired)) {
				localStorage.removeItem("share");
				console.log("Remove localStore");
			}
			return new Promise((resolve) =>
				resolve(JSON.stringify({ value, expired }))
			);
		} else {
			console.log("Call-Service");
			return getShareAndDisableNavigation(queryParam).then((data) => {
				const jsonStory = JSON.stringify({
					story: data.story,
					couple: data.couple,
					img: data.images,
				});
				const elementId = data.element_id;
				const generalDisabledPrices = data.disabled_prices;
				localStorage.setItem(
					"share",
					JSON.stringify({
						value: `${queryParam}|*|${data.disabled_nav}|*|${jsonStory}|*|${generalDisabledPrices}|*|${elementId}|*|${data.disabled_menus}`,
						expired: date,
					})
				);
				if (data.disabled_nav == 1) {
					document
						.querySelector(".header__burger-lines")
						.classList.add("hidden");
					document.querySelector(".header__brand-logo").href = "#";
				}

				return new Promise((resolve) =>
					resolve(
						JSON.stringify({
							value: `${queryParam}|*|${data.disabled_nav}|*|${jsonStory}|*|${generalDisabledPrices}|*|${elementId}|*|${data.disabled_menus}`,
							expired: date,
						})
					)
				);
			});
		}
	} else {
		console.log("Call-Empty");
        const pathname = window.location.pathname; // Get the pathname from the URL
        const segments = pathname.split('/'); // Split the pathname into segments
        const lastSlug = segments.filter(Boolean).pop();

        if( '077750'==lastSlug  && localStorage.getItem("disable_nav") === null ){
            console.log('Disabled Prices');
            const date = is_live == "1" ? new Date().addHours(1) : new Date().addMinutes(5);
            localStorage.setItem("disable_nav", JSON.stringify({ expired: date }));
            localStorage.removeItem("share");
        }

		if (localStorage.getItem("share") !== null) {
			const { value, expired } = JSON.parse( localStorage.getItem("share") );
			if (new Date() > new Date(expired)) {
				localStorage.removeItem("share");
				console.log("Expired and remove localStore");
				return new Promise((resolve) => resolve(JSON.stringify({ value: "{}", expired: "" })));
			} else {
				console.log("Not Expired");
				return new Promise((resolve) => resolve(JSON.stringify({ value, expired })));
			}
		}
		return new Promise((resolve) =>
			resolve(JSON.stringify({ value: "{}", expired: "" }))
		);
	}
}

/**
 * Retrieves share information and disables navigation.
 *
 * @param {string} shareKey - The key for the share
 * @return {Promise} A Promise that resolves to the share information
 */
function getShareAndDisableNavigation(shareKey) {
	const req = new FormData();
	req.append("operation", "getShare");
	req.append("shareKey", shareKey);
	req.append("clientFolder", CLIENT_FOLDER);

	return fetch(`${site_url}ajax/functions.php`, { method: "POST", body: req })
		.then((resp) => resp.json())
		.then((data) => data);
}

/**
 * Function to handle middleware referral logic.
 *
 * @return {Promise} A promise that resolves to a string representing the share local store.
 */
function middlewareReferall() {
	if (!checkIfExistReferral()) {
		document.querySelector(".header__burger-lines").classList.remove("hidden");
	} else {
		document.querySelector(".header__brand-logo").href = "#";
	}
	return checkShareLocalStore().then((stringShare) => stringShare);
}

/**
 * Increments views for a specific share by making a GET request to the server.
 *
 * @param {string} shareKey - The key of the share for which views are to be incremented.
 * @return {Promise} A Promise that resolves with the response from the server or rejects with an error.
 */
function incrementViews(shareKey) {
	return new Promise((resolve, reject) => {
		fetch(
			`${site_url}ajax/functions.php?operation=incrementShareViews&shareKey=${shareKey}&site_id=${site_id}`,
			{
				method: "GET",
			}
		)
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

/**
 * Fetches menus from the server based on the given menu IDs, selected language, and tags.
 *
 * @param {Array<number>} menuIds - An array of menu IDs.
 * @param {string} [langSelected='en'] - The selected language. Defaults to 'en' if not provided.
 * @param {string} [tags=''] - The tags to filter the menus. Defaults to an empty string if not provided.
 * @return {Promise<Response>} A promise that resolves to the response from the server.
 */
function fetchMenus(menuIds, langSelected = "en", tags = "") {
	return new Promise((resolve, reject) => {
		fetch(
			`${site_url}ajax/functions.php?operation=getMenus&menuIds=${menuIds.toString()}&lang=${langSelected}&tags=${tags}`,
			{
				method: "GET",
			}
		)
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

/**
 * Fetch categories based on menu ID, category IDs, and selected language.
 *
 * @param {type} idMenu - description of the menu ID parameter
 * @param {type} categoriesIds - description of the category IDs parameter
 * @param {type} langSelected - description of the selected language parameter
 * @return {type} Promise that resolves with the fetched response or rejects with an error
 */
function fetchCategories(idMenu, categoriesIds, langSelected) {
	return new Promise((resolve, reject) => {
		fetch(
			`${site_url}ajax/functions.php?operation=getCategoriesMenus&menu=${idMenu}&categoriesIds=${categoriesIds.toString()}&lang=${langSelected}`,
			{
				method: "GET",
			}
		)
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

/**
 * Fetches products from the server based on the given parameters.
 *
 * @param {number} idCategory - The ID of the category.
 * @param {number} menuId - The ID of the menu.
 * @param {Array<number>} productsIds - An array of product IDs.
 * @param {string} langSelected - The selected language.
 * @param {boolean} disabledPrices - Indicates whether prices are disabled.
 * @return {Promise<Response>} A promise that resolves to the response from the server.
 */
function fetchProducts( idCategory, menuId, productsIds, langSelected, disabledPrices) {

    if (localStorage.getItem("disable_nav")) {
		const { expired } = JSON.parse(localStorage.getItem("disable_nav"));
		if (new Date() > new Date(expired)) {
            console.log('Expired and removing');
			localStorage.removeItem("disable_nav");
		}else{
            console.log("Continue @+", new Date(expired), new Date());
            disabledPrices = 1;
        }
	}

	return new Promise((resolve, reject) => {
		fetch(
			`${site_url}ajax/functions.php?operation=getProductsMenus&category=${idCategory}&menu=${menuId}&productsIds=${productsIds.toString()}&lang=${langSelected}&disabled_prices=${disabledPrices}`,
			{
				method: "GET",
			}
		)
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

function fetchEntries(selectBlogid, entryIds, langSelected = "en", module) {
    console.log('module', module);
	return new Promise((resolve, reject) => {
		fetch(
			`${site_url}ajax/functions.php?operation=geEntries&blogId=${selectBlogid}&entryIds=${entryIds.toString()}&lang=${langSelected}&module=${module}`,
			{
				method: "GET",
			}
		)
			.then((response) => resolve(response))
			.catch((error) => reject(error));
	});
}

function getExperiences( tag = 'all',selectBlogid ,langSelected='en'){
    return new Promise((resolve, reject) => {
        fetch(`${site_url}ajax/functions.php?operation=getExperiences&selected_blog=${selectBlogid}&tag=${tag}&lang=${langSelected}`,{method: "GET"}) 
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
}

/**
 * Loads your story data using a promise to handle asynchronous operations.
 *
 * @return {Promise} A promise that resolves when the story data is loaded successfully, or rejects with an error.
 */
function loadYourStoryData() {
	return new Promise((resolve, reject) => {
		if (document.querySelector(".js-loader"))
			document.querySelector(".js-loader").classList.add("loading");
		middlewareReferall()
			.then((shareLocalStorage) => {
				const { value, expired } = JSON.parse(shareLocalStorage);
				const [
					shareKey,
					disabledNav,
					shareAddition,
					generalDisabledPrices,
					elementsId,
					disabledMenus,
				] = value.split("|*|");

				const disabledMenusElement =
					document.querySelector(".js-disabledMenus");
				const privaryNavigationElement = document.querySelector(
					".privary-navigation"
				);

				if (disabledMenusElement && disabledMenus === "1") {
					console.log("Diabled Menus");
					disabledMenusElement.classList.add("hidden");
				}

				if (privaryNavigationElement && disabledMenus === "1") {
					console.log("Diabled Navigation");
					const liMenu =
						privaryNavigationElement.querySelectorAll("ul li")[2];
					if (liMenu) liMenu.remove();
				}

				if (shareAddition !== undefined) {
					const sAddition = JSON.parse(shareAddition);

					if (sAddition.couple && document.querySelector(".js-title"))
						document.querySelector(
							".js-title"
						).innerHTML = `${sAddition.couple}`;
					if (sAddition.story && document.querySelector(".js-copy"))
						document.querySelector(
							".js-copy"
						).innerHTML = `${sAddition.story}`;
					if (sAddition.img && document.querySelector(".js-image")) {
						let images = "";
						Object.keys(sAddition.img).forEach((tag) => {
							sAddition.img[tag].forEach((image) => {
								images += `<img src="${image.src}" alt="${image.alt}" />`;
							});
						});
						document.querySelector(".js-image").innerHTML = images;
					}
                    if (document.querySelector(".js-loader") && sAddition.couple !== null && sAddition.story !== null && sAddition.img !== null) {
                        document.querySelector(".js-loader").style.display = "block";
                    }
				}
				resolve();
			})
			.catch((e) => {
				console.log("Error--> loadInitialData:", e.message);
				reject(e);
			})
			.finally(() => {
				if (document.querySelector(".js-loader")){
					document.querySelector(".js-loader").classList.remove("loading");
                }
			});
	});
}

